import { css } from '@emotion/css'

import { shorthandHelper, spacing } from '@offerzen/pinata'

const styles = {
  card: css({
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: shorthandHelper([spacing.extraLarge, spacing.large]),
    marginTop: spacing.extraLarge,

    '& > img': {
      marginBottom: spacing.large,
      maxWidth: '100%',
    },
  }),

  button: css({
    marginTop: spacing.large,
  }),
}

export default styles
